import React, { Component } from 'react';
import AriaModal from 'react-aria-modal';
import Lang from 'libraries/Lang';

class LoadingModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            disable: false,
        }        
    }
    render() {
        const { isLoading } = this.props;
        return (
           <>
            { (isLoading == true) ? 
                <AriaModal
                onExit="javascript:;"
                initialFocus="#mdl-content"
                aria-describedby="mdl-content"
                titleId="mdl-title"
                aria-labelledby="mdl-title"
                dialogStyle={{ width: '1000px' }}
                aria-modal="true"
                verticallyCenter >
                <div className="modal-dialog px-3 hourglass-loader">
                    <div className="modal-content modal">
                        <div className="modal-header p-0">
                            <h3 className="modal-title">
                                <div className="header-text">
                                    
                                   
                                </div>
                            </h3>
                            <button
                                type="button"
                                className="close close-lg pt-3"
                                aria-label="Close"
                            >                                      
                            </button>
                        </div>
                        <div className="modal-main px-4 pb-4 pt-0" id="mdl-content">
                            <div className="row text-center">
                            <div className="col-12">
                                  <div>
                                      <img src="https://travelbrandsagent.s3.us-east-1.amazonaws.com/img/hourglass-loader.gif"/>
                                  </div>
                                  <h3 className="modal-title" id="mdl-title">
                                    {Lang.trans('loadingModel.please_wait')}
                                       <svg className="position-absolute" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="65px" viewBox="0 0 100 100">
                                              <g transform="translate(20 50)">
                                              <circle cx="0" cy="0" r="6" fill="#221E1F">
                                              <animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                                              </circle>
                                              </g><g transform="translate(40 50)">
                                              <circle cx="0" cy="0" r="6" fill="#221E1F">
                                              <animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                                              </circle>
                                              </g><g transform="translate(60 50)">
                                              <circle cx="0" cy="0" r="6" fill="#221E1F">
                                              <animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                                              </circle>
                                              </g><g transform="translate(80 50)">
                                              <circle cx="0" cy="0" r="6" fill="#221E1F">
                                              <animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform>
                                              </circle>
                                              </g>
                                          </svg>
                                    </h3>
                            </div>
                              {/* <div className="col-6 mb-3 ">
                                  <img src="https://travel-img-assets.s3.us-west-2.amazonaws.com/logos/logo-access-TB.png" alt="Travel Brand Logo" class="logo mb-0 pl-0 pt-0 w-50"/>
                              </div> */}
                              <div className="col-12">
                                  <h5 className=""> {Lang.trans('loadingModel.we_are_processing')} </h5>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
            </AriaModal> 
            : null }
              </>
        );
    }
}

export default LoadingModal;
